import { render, staticRenderFns } from "./ClearSurveyResponsesConfirmationDialog.vue?vue&type=template&id=25f15830"
import script from "./ClearSurveyResponsesConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ClearSurveyResponsesConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f15830')) {
      api.createRecord('25f15830', component.options)
    } else {
      api.reload('25f15830', component.options)
    }
    module.hot.accept("./ClearSurveyResponsesConfirmationDialog.vue?vue&type=template&id=25f15830", function () {
      api.rerender('25f15830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/ClearSurveyResponsesConfirmationDialog.vue"
export default component.exports